import React from "react";
import TitleSection from "../components/TitleSection";
import asset2 from "../assets/asset2.svg";
import num1 from "../assets/1.svg";
import num2 from "../assets/2.svg";
import num3 from "../assets/3.svg";
import num4 from "../assets/4.svg";

const features = [
  {
    icon: num1,
    text: `واجهة مستخدم\nودروس بلغات متعددة\nلتلبية احتياجات الطلاب\nمن خلفيات متنوعة.`,
  },
  {
    icon: num2,
    text: `مكتبة تضم كتب\nإلكترونية، مقالات،\nوأبحاث إضافية لدعم\nالتعلم`,
  },
  {
    icon: num3,
    text: `محتوى تعليمي مقسم\nإلى وحدات صغيرة\nوسهلة الفهم والتعلم\nمع وجود اختيارات.`,
  },
  {
    icon: num4,
    text: `إمكانية الوصول إلى\nالمحتوى التعليمي عبر\nالهواتف الذكية\nوالأجهزة اللوحية.`,
  },
];

const Overview = ({ data }) => {
  return (
    <div className="flex flex-col ">
      <div
        dir="rtl"
        id="overview"
        className="flex flex-col-reverse md:flex-row items-center justify-between w-[90%] mx-auto py-10 gap-8"
      >
        {/* Text Section */}
        <div className="w-full md:w-1/2">
          <TitleSection
            title="لمحة عنا"
            desc={data?.data?.data?.about_us?.description}
          />
        </div>

        {/* Image Section */}
        <div className="w-full md:w-1/2 flex justify-end">
          <img src={asset2} alt="لمحة" className="max-w-full h-auto" />
        </div>
      </div>

      {/* لماذا نحن Section */}
      <div id="features" className="w-[90%] mx-auto">
        <TitleSection
          title="لماذا نحن"
          desc={""}
        />

        {/* Feature Items */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-6" dir="rtl">
          {features.map((item, index) => (
            <div
              key={index}
              className="relative flex flex-col items-center text-center bg-white p-4 md:p-10"
            >
              {/* الزاوية العلوية اليسرى */}
              <span className="absolute top-0 left-0 w-20 h-20 border-t-2 border-l-2 border-black rounded-tl-3xl" />

              {/* الزاوية السفلية اليمنى */}
              <span className="absolute bottom-0 right-0 w-20 h-20 border-b-2 border-r-2 border-black rounded-br-3xl" />

              <img
                src={item.icon}
                alt={`Number ${index + 1}`}
                className="w-12 h-12 mb-4"
              />
              <p className="whitespace-pre-line text-xs md:text-lg text-[#333] leading-loose">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div >

  );
};

export default Overview;
